import { createAsyncThunk } from '@reduxjs/toolkit';
import RoadmapAPI from './roadmapApi';

export const fetchRoadmapItemsThunk = createAsyncThunk(
  'roadmap/fetchItems',
  async (params, { rejectWithValue }) => {
    try {
      return await RoadmapAPI.fetchItems(params);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load roadmap items');
    }
  }
);

export const createRoadmapItemThunk = createAsyncThunk(
  'roadmap/createItem',
  async (itemData, { rejectWithValue }) => {
    try {
      return await RoadmapAPI.createItem(itemData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create roadmap item');
    }
  }
);

export const updateRoadmapItemThunk = createAsyncThunk(
  'roadmap/updateItem',
  async ({ itemId, updates }, { rejectWithValue }) => {
    try {
      return await RoadmapAPI.updateItem(itemId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update roadmap item');
    }
  }
);

export const deleteRoadmapItemThunk = createAsyncThunk(
  'roadmap/deleteItem',
  async (itemId, { rejectWithValue }) => {
    try {
      return await RoadmapAPI.deleteItem(itemId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete roadmap item');
    }
  }
);
